<ion-input
  [id]="id"
  [placeholder]="placeholder"
  [label]="label"
  label-placement="stacked"
  [fill]="fill"
  [mode]="mode"
  [readonly]="true"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-expanded]="isOpen()"
  (click)="openPopover()"
  (keydown)="onTriggerKeydown($event)"
  [value]="displayLabel()"
  [class]="getClasses() + (inputClassName ? ' ' + inputClassName : '')"
  [disabled]="disabled"
>
  <ng-content select="[start]" />
  <ion-icon 
    slot="end" 
    [name]="isOpen() ? 'caret-up' : 'caret-down'" 
    color="medium"
    size="small"
    aria-hidden="true"
  ></ion-icon>
</ion-input>
<ion-popover *ngIf="!disabled"
  [isOpen]="isOpen()"
  (willDismiss)="closePopover()"
  (didPresent)="onDidPresent()"
  [trigger]="id"
  size="cover"
>
  <ng-template>
    <ion-list>
      <ion-item>
        <ion-input
          #searchInput
          (ionInput)="onSearchChanged($event)"
          [placeholder]="'frontend_filter_search' | translate"
          clearInput
          autoFocus
        />
      </ion-item>
      <ng-content />
    </ion-list>
  </ng-template>
</ion-popover>
